<script lang="ts" setup>
import type { CareerBox } from '~/components/career/box/CareerBox.vue'
export interface WidgetCareerProps {
    data: {
        title: string
        tag: string
        data: CareerBox[]
        cta_text: string
    }
    headingLevel?: string
}
const props = defineProps<WidgetCareerProps>()
</script>
<template>
  <section
    class="bg-white rounded py-10 px-2 px-md-6 box-shadow-1"
    data-cy="widget_career"
  >
    <Tracker :data="{ position: props.data.title }">
      <header class="text-center mb-3">
        <Tag
          size="small"
          background-color="gray-1"
          text-color="primary"
          class="text-uppercase mx-auto mb-3"
        >
          {{ props.data.tag || $t('Kariéra u nás') }}
        </Tag>
        <Heading
          :level="props.headingLevel || 'h3'"
          class="beta mb-3"
        >
          {{ props.data.title }}
        </Heading>
        <VButton
          :to="{ name: 'career' }"
          color="primary"
          size="small"
          :label="props.data.cta_text"
          class="mb-4 fw-normal"
        >
          {{ props.data.cta_text }}
        </VButton>
      </header>
      <CareerBoxList :data="props.data.data" />
    </Tracker>
  </section>
</template>
